import React from 'react';

export default (props) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14.2 2.7C14.1 1.4 12.8 0 11.3 0H2.9C1.2 0 0 1.6 0 3V13.5C0 14.9 1.1 16 2.5 16H13.4C14.8 16 15.9 14.9 15.9 13.5V5.1C16 4 15.3 3 14.2 2.7ZM2.5 2.6C2.1 2.6 1.7 2.7 1.4 2.8C1.5 2.3 2.1 1.4 2.8 1.4H11.2C12 1.4 12.5 2.1 12.6 2.5H2.5V2.6ZM1.4 5.1C1.4 4.5 1.9 4 2.5 4H13.4C14 4 14.5 4.5 14.5 5.1V6.4H11.1C9.6 6.4 8.4 7.6 8.4 9.1C8.4 10.6 9.6 11.8 11.1 11.8H14.5V13.5C14.5 14.1 14 14.6 13.4 14.6H2.5C1.9 14.6 1.4 14.1 1.4 13.5V5.1ZM9.9 9.1C9.9 8.4 10.5 7.8 11.2 7.8H14.6V10.3H11.2C10.5 10.3 9.9 9.8 9.9 9.1Z" fill="currentColor" />
  </svg>
);
